import { render, staticRenderFns } from "./DisputeShipmentInfo.vue?vue&type=template&id=292afffa"
import script from "./DisputeShipmentInfo.vue?vue&type=script&lang=js"
export * from "./DisputeShipmentInfo.vue?vue&type=script&lang=js"
import style0 from "./DisputeShipmentInfo.vue?vue&type=style&index=0&id=292afffa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports